exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".border {\n  border-bottom: 1px solid #fff; }\n\n.dropdown-menu-right li:first-child .border {\n  border-top: 1px solid #fff; }\n\n.dropdown-menu-right li a {\n  color: #287fc4; }\n\n.dropdown-menu-right li :hover {\n  background: none;\n  color: #287fc4;\n  cursor: pointer; }\n\n.box.box-default {\n  border-bottom: none; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/components/toolbar/toolbar.scss
// module id = 951
// module chunks = 22